module.exports = __webpack_public_path__ + "static/media/send-button.b79d5ca5.svg";